var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0889 2.27456C14.2654 2.09186 14.363 1.84715 14.3608 1.59314C14.3586 1.33914 14.2567 1.09617 14.0771 0.916553C13.8975 0.736939 13.6545 0.635056 13.4005 0.632849C13.1465 0.630642 12.9018 0.728286 12.7191 0.904752L5.64722 7.97663L2.45035 4.77975C2.26764 4.60329 2.02293 4.50564 1.76893 4.50785C1.51492 4.51006 1.27195 4.61194 1.09233 4.79155C0.91272 4.97117 0.810838 5.21414 0.80863 5.46814C0.806423 5.72215 0.904068 5.96686 1.08053 6.14957L4.95553 10.0246C5.1372 10.2062 5.38356 10.3082 5.64044 10.3082C5.89732 10.3082 6.14368 10.2062 6.32535 10.0246L14.0753 2.27456H14.0889Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.a76d2ecf6e582426bfefc092145f5558.svg";
export { ForwardRef as ReactComponent };